const SkeletonBox = ({
  width,
  height,
  radius = 4,
  className = "",
}: {
  width?: string | number;
  height: number;
  radius?: number;
  className?: string;
}) => (
  <div
    className={`bg-surface-tonal-default animate-pulse ${className}`}
    style={{
      width: width ?? "100%",
      height,
      borderRadius: radius,
      flexShrink: 0,
    }}
  />
);

/** Skeleton for a single label + input row (MultiSelect) */
const RowSkeleton = () => (
  <div className="flex flex-col gap-2">
    {/* label */}
    <SkeletonBox width={88} height={20} radius={4} />
    {/* input */}
    <SkeletonBox height={40} radius={8} />
  </div>
);

/** Skeleton for the Platform toggle row */
const PlatformRowSkeleton = () => (
  <div className="flex flex-col gap-2">
    {/* label */}
    <SkeletonBox width={88} height={20} radius={4} />
    {/* toggle group */}
    <SkeletonBox height={40} radius={8} />
  </div>
);

/** Skeleton for a modal's footer buttons — render as the `footer` prop, not inside content */
export const ModalFooterSkeleton = ({
  isMobile,
}: {
  isMobile?: boolean;
}) =>
  isMobile ? (
    <div className="flex flex-col items-center gap-3">
      <div className="flex w-full gap-2">
        <div className="flex-1">
          <SkeletonBox height={40} radius={8} />
        </div>
        <div className="flex-1">
          <SkeletonBox height={40} radius={8} />
        </div>
      </div>
      {/* Home indicator */}
      <SkeletonBox width={128} height={4} radius={8} />
    </div>
  ) : (
    <div className="flex justify-end gap-2">
      <SkeletonBox width={102} height={40} radius={8} />
      <SkeletonBox width={102} height={40} radius={8} />
    </div>
  );

/** Skeleton for a modal's form body (label + field rows + a platform toggle row) */
export const ModalFormSkeleton = () => (
  <div className="flex flex-col gap-6">
    {/* Target page */}
    <RowSkeleton />
    {/* Language */}
    <RowSkeleton />
    {/* Platform */}
    <PlatformRowSkeleton />
    {/* Rebate program */}
    <RowSkeleton />
  </div>
);
